"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InspectionImage = exports.InspectionList = exports.InspectionCriteriaResponse = exports.InspectionCriteria = exports.PaymentTerm = exports.RFQDuration = void 0;
var RFQDuration;
(function (RFQDuration) {
    RFQDuration["Daily"] = "daily";
    RFQDuration["Weekly"] = "weekly";
    RFQDuration["Monthly"] = "monthly";
})(RFQDuration = exports.RFQDuration || (exports.RFQDuration = {}));
var PaymentTerm;
(function (PaymentTerm) {
    PaymentTerm[PaymentTerm["DAYS_15"] = 15] = "DAYS_15";
    PaymentTerm[PaymentTerm["DAYS_30"] = 30] = "DAYS_30";
    PaymentTerm[PaymentTerm["DAYS_45"] = 45] = "DAYS_45";
    PaymentTerm[PaymentTerm["DAYS_60"] = 60] = "DAYS_60";
})(PaymentTerm = exports.PaymentTerm || (exports.PaymentTerm = {}));
var InspectionCriteria;
(function (InspectionCriteria) {
    InspectionCriteria["CabinSideMirrorsEtc"] = "cabin-side-mirrors-etc";
    InspectionCriteria["HornDashboardMonitoringGuage"] = "horn-dashboard-monitoring-guage";
    InspectionCriteria["LightsIncludingLightCovers"] = "lights-including-light-covers";
    InspectionCriteria["ReverseAlarmLights"] = "reverse-alarm-lights";
    InspectionCriteria["FireExtingusher"] = "fire-extingusher";
    InspectionCriteria["WindsheildWipersFluid"] = "windsheild-wipers-fluid";
    InspectionCriteria["BrakeCondition"] = "brake-condition";
    InspectionCriteria["TiresTracks"] = "tires-tracks";
    InspectionCriteria["BladeBloomCondition"] = "blade-bloom-condition";
    InspectionCriteria["HydraulicOil"] = "hydraulic-oil";
    InspectionCriteria["EngineOil"] = "engine-oil";
    InspectionCriteria["TransmissionFluid"] = "transmission-fluid";
    InspectionCriteria["BrakeFluid"] = "brake-fluid";
    InspectionCriteria["CoolingSystemFluid"] = "cooling-system-fluid";
    InspectionCriteria["OilLeakLube"] = "oil-leak-lube";
    InspectionCriteria["HoseCondition"] = "hose-condition";
    InspectionCriteria["ExhaustSystem"] = "exhaust-system";
    InspectionCriteria["CouplingDevicesConnectors"] = "coupling-devices-connectors";
    InspectionCriteria["TurnLights"] = "turn-lights";
    InspectionCriteria["Battery"] = "battery";
    InspectionCriteria["ElecticalSystemConditions"] = "electical-systemConditions";
    InspectionCriteria["ServiceMaintenance"] = "service-maintenance";
})(InspectionCriteria = exports.InspectionCriteria || (exports.InspectionCriteria = {}));
var InspectionCriteriaResponse;
(function (InspectionCriteriaResponse) {
    InspectionCriteriaResponse["Good"] = "Good";
    InspectionCriteriaResponse["NeedRepair"] = "NeedRepair";
    InspectionCriteriaResponse["NA"] = "NA";
})(InspectionCriteriaResponse = exports.InspectionCriteriaResponse || (exports.InspectionCriteriaResponse = {}));
exports.InspectionList = [
    { criteria: InspectionCriteria.CabinSideMirrorsEtc,
        description: "Cabin, Side Mirrors, Seat Belt, Air Condition & Glass",
    },
    { criteria: InspectionCriteria.HornDashboardMonitoringGuage,
        description: "Horn & dashboard monitoring guages",
    },
    { criteria: InspectionCriteria.LightsIncludingLightCovers,
        description: "Lights including light covers",
    },
    { criteria: InspectionCriteria.ReverseAlarmLights,
        description: "Reverse Alarm & Lights",
    },
    { criteria: InspectionCriteria.FireExtingusher,
        description: "Fire Extingusher",
    },
    { criteria: InspectionCriteria.WindsheildWipersFluid,
        description: "Windsheild wipers & fluid",
    },
    { criteria: InspectionCriteria.BrakeCondition,
        description: "Brake condition (dynamic service, park, etc)",
    },
    { criteria: InspectionCriteria.TiresTracks,
        description: "Tires or Tracks (Inflation, crack, damages, etc)",
    },
    { criteria: InspectionCriteria.BladeBloomCondition,
        description: "Blade/Ripper/Screed/Bloom condition",
    },
    { criteria: InspectionCriteria.HydraulicOil,
        description: "Hydraulic Oil",
    },
    { criteria: InspectionCriteria.EngineOil,
        description: "Engine Oil",
    },
    { criteria: InspectionCriteria.TransmissionFluid,
        description: "Transmission Fluid",
    },
    { criteria: InspectionCriteria.BrakeFluid,
        description: "Brake Fluid",
    },
    { criteria: InspectionCriteria.CoolingSystemFluid,
        description: "Cooling System Fluid",
    },
    { criteria: InspectionCriteria.OilLeakLube,
        description: "Oil leak/lube",
    },
    { criteria: InspectionCriteria.HoseCondition,
        description: "Hose condition",
    },
    { criteria: InspectionCriteria.ExhaustSystem,
        description: "Exhaust system (free from black smoke etc)",
    },
    { criteria: InspectionCriteria.CouplingDevicesConnectors,
        description: "Coupling devices & connectors",
    },
    { criteria: InspectionCriteria.TurnLights,
        description: "Turn Lights",
    },
    { criteria: InspectionCriteria.Battery,
        description: "Battery (charge, connection, etc)",
    },
    { criteria: InspectionCriteria.ElecticalSystemConditions,
        description: "Electical system conditions",
    },
    { criteria: InspectionCriteria.ServiceMaintenance,
        description: "Service maintenance record maintained and available",
    },
];
var InspectionImage;
(function (InspectionImage) {
    InspectionImage["FrontSide"] = "front-side";
    InspectionImage["BackSide"] = "back-side";
    InspectionImage["LeftSide"] = "left-side";
    InspectionImage["RightSide"] = "right-side";
    InspectionImage["CabinInterior"] = "cabin-interior";
    InspectionImage["Dashboard"] = "dashboard";
    InspectionImage["UnderChasis"] = "under-chasis";
    InspectionImage["Engine"] = "engine";
    InspectionImage["TyreFrontLeft"] = "tyre-front-left";
    InspectionImage["TyreFrontRight"] = "tyre-front-right";
    InspectionImage["TyreBackLeft"] = "tyre-back-left";
    InspectionImage["TyreBackRight"] = "tyre-back-right";
    InspectionImage["HydraulicHose1"] = "hydraulic-hose-1";
    InspectionImage["HydraulicHose2"] = "hydraulic-hose-2";
    InspectionImage["HydraulicHose3"] = "hydraulic-hose-3";
    InspectionImage["HydraulicHose4"] = "hydraulic-hose-4";
})(InspectionImage = exports.InspectionImage || (exports.InspectionImage = {}));
//# sourceMappingURL=rfq.js.map